import DriverView from '../../components/drivers/DriverView'
import { connect } from 'react-redux'
import { IStateDriver, IHistoryDriverTrips, IStoreState } from '../../types'
import { restoreFromArchive, archiveDriver, getSingleDriver, getTripsHistoryDriver } from '../../state/actions/drivers/'
import { RouteComponentProps } from 'react-router-dom'
import { getDriverById } from '../../state/reducers/drivers'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  const driver = state.drivers.items[ownProps.match.params.id]
  return {
    driverInfo: driver,
    loading: state.drivers.isSelectedDriverFetch || state.drivers.processing,
    loadingError: state.drivers.selectedDriverError || state.drivers.processingError,
    historyDriverTrips: state.drivers.historyDriverTrips,
    selectedTrip: state.drivers.selectedHistoryTrip,
    isHistoryDriverTripsRequesting: state.drivers.isHistoryDriverTripsRequesting,
    routeProps: ownProps
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getDriverById: (id: string) => dispatch(getSingleDriver(id)),
    archiveDriver: (item: any) => dispatch(archiveDriver(item)),
    restoreDriverFromArchive: (item: any) => dispatch(restoreFromArchive(item)),
    getTripsHistoryDriver: () => dispatch(getTripsHistoryDriver())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverView)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriverView.ts